"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import CountUp from "react-countup";
import directionIcon from '../../assets/images/icon/event-direction-chat-icon.png';

export default function EventDirection() {
  // State for dynamic content
  const [eventContent] = useState({
    tagline: "Why Choose U Brand It",
    title: "Your Partner in Building Brand Success",
    text: "We specialize in helping businesses make lasting impressions with quality promotional products and branded merchandise. Trust us to deliver on time, on point, and on budget.",
    phone: "8007215822",
    callText: "Call Us Today",
    callNumber: "800-721-5822",
    iconSrc: directionIcon,
  });

  return (
    <>
      {/* Event Direction Start */}
      <section className="event-direction">
        <div className="container">
          <div className="event-direction__inner">
            <div className="row">
              <div className="col-xl-7 wow fadeInLeft" data-wow-delay="100ms">
                <div className="event-direction__left">
                  <div className="section-title text-left">
                    <div className="section-title__tagline-box">
                      <span className="section-title__tagline">{eventContent.tagline}</span>
                    </div>
                    <h2 className="section-title__title">
                      Your Partner in <br /> Building Brand Success
                    </h2>
                  </div>
                  <p className="event-direction__text">
                    We specialize in helping businesses make lasting impressions with quality promotional products and branded merchandise. <br />
                    Trust us to deliver on time, on point, and on budget.
                  </p>
                  <div className="event-direction__call">
                    <div className="event-direction__call-icon">
                      <img src={eventContent.iconSrc} alt="Call Icon" />
                    </div>
                    <div className="event-direction__call-content">
                      <p>{eventContent.callText}</p>
                      <h4><a href={`tel:${eventContent.phone}`}>{eventContent.callNumber}</a></h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 wow fadeInRight" data-wow-delay="300ms">
                <div className="event-direction__right">
                <ul className="event-direction__counter list-unstyled">
                    <li>
                      <div className="event-direction__counter-single">
                        <div className="event-direction__counter-box">
                          <h3 className="odometer">
                            <CountUp start={0} end={500} duration={2} />
                          </h3>
                          <span className="event-direction__counter-plus">
                            +
                          </span>
                        </div>
                        <p className="event-direction__counter-text">
                          Happy Clients
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="event-direction__counter-single">
                        <div className="event-direction__counter-box">
                          <h3 className="odometer">
                            <CountUp start={0} end={1000} duration={2} />
                          </h3>
                          <span className="event-direction__counter-plus">
                            +
                          </span>
                        </div>
                        <p className="event-direction__counter-text">
                          Product Options
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="event-direction__counter-single">
                        <div className="event-direction__counter-box">
                          <h3 className="odometer">
                            <CountUp start={0} end={100} duration={2} />
                          </h3>
                          <span className="event-direction__counter-plus">
                            %
                          </span>
                        </div>
                        <p className="event-direction__counter-text">
                          Your Brand
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="event-direction__counter-single">
                        <div className="event-direction__counter-box">
                          <h3 className="odometer">
                            <CountUp start={0} end={100} duration={2} />
                          </h3>
                          <span className="event-direction__counter-plus">
                            %
                          </span>
                        </div>
                        <p className="event-direction__counter-text">
                          Satisfaction Rate
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Direction End */}
    </>
  );
}
